/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { CalculationType } from "../../types/CalculationType";
export const CreateCalculationRequest = core.serialization.object({
    fieldKey: core.serialization.string(),
    type: CalculationType,
});
